module.exports = __webpack_public_path__ + "img/download.0817a3cf.svg";